import { formatUnits, parseUnits } from "viem";
import { useAccount } from "wagmi";

import { useDelegationsQuery } from "shared/api/cosmos/use-delegations-query";
import { useDelegatorRewardsQuery } from "shared/api/cosmos/use-delegator-rewards-query";
import { useDelegatorValidatorsQuery } from "shared/api/cosmos/use-delegator-validators-query";
import { formatCurrency } from "shared/web3/utils";

import { Header } from "../table/header";
import { Table } from "../table/table";
import bgImg from "./bg.png";
import { Card } from "./card";
import { Row } from "./row";

export const MainScreen = () => {
  const { address } = useAccount();
  const delegatorValidatorsQuery = useDelegatorValidatorsQuery({ address });

  const validators = delegatorValidatorsQuery.data?.validators ?? [];

  const query = useDelegatorRewardsQuery();
  const formattedRewards = query.data?.total?.[0]?.amount
    ? formatCurrency(formatUnits(parseUnits(query.data.total[0].amount, 0), 18))
    : "-";

  const delegationsQuery = useDelegationsQuery({ address });
  const stake = delegationsQuery.data?.delegation_responses
    ?.map(({ balance }) => balance?.amount)
    .reduce((acc, balance) => {
      const parsedBalance = parseUnits(balance ?? "0", 0);
      acc = acc + parsedBalance;
      return acc;
    }, 0n);

  const formattedStake = formatCurrency(formatUnits(stake ?? 0n, 18));
  return (
    <main
      className="flex flex-col rounded-xl bg-cover bg-center px-6 py-5"
      style={{
        background: `url(${bgImg})`,
      }}
    >
      <h1 className="text-balticSea text-lg font-semibold">Dashboard</h1>
      <div className="mt-3 grid grid-cols-3 gap-x-4">
        <Card suffix="GNET" title="My stake" value={`${formattedStake}`} />
        <Card
          suffix="GNET"
          title="Unclaimed rewards"
          value={`${formattedRewards}`}
        />
        <Card suffix="%" title="Projected APY" value="1,105.2" />
      </div>
      <div className="border-mistBlue/10 mt-5 flex flex-col rounded-xl border bg-white/70 px-4 py-3.5">
        <h2 className="text-lg">My positions</h2>

        <Table className="mt-4">
          <Header />
          {validators.map((validator, index) => {
            return <Row index={index} key={index} validator={validator} />;
          })}
        </Table>
      </div>
    </main>
  );
};
